var app = angular.module('intranetApp');

// 
/**
 *  Converts MySQL datetime into readable format
 *  Example: 2013-10-18 18:47:15 into 1382122035000 so angular can format date
 *  @param {string} The MySQL DateTime
 *  @returns {string} ISO Formatted Date
*/

app.filter('mysqlDateFilter', function() {
    return function(mysqlDate) {
        var date = mysqlDate.replace(/-/g, "/"); // Replaces hyphens with slashes
        return Date.parse(date); // No TZ subtraction on this sample
    };
});
//# sourceMappingURL=app.filters.js.map
